import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";

import { PDFViewerProps } from "./types";

import "@react-pdf-viewer/core/lib/styles/index.css";

const PDFViewer = ({ pdfLink }: PDFViewerProps) => {
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <Viewer fileUrl={pdfLink} defaultScale={0.55} />
    </Worker>
  );
};

export default PDFViewer;
